module.exports = __webpack_public_path__ + "static/media/radar2.a6ca38ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/radar2.svg
// module id = 263
// module chunks = 0